"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.concurrentLoop = concurrentLoop;
exports.serialLoop = serialLoop;
exports.getAverage = getAverage;
exports.setTimeoutPromise = setTimeoutPromise;
exports.exponentialRetry = exponentialRetry;
exports.trimRight = trimRight;
exports.trimLeft = trimLeft;
exports.joinUrlPath = joinUrlPath;
exports.trimContentDam = trimContentDam;
exports.normalizePath = normalizePath;
exports.isTempPath = isTempPath;
exports.walkDirectory = walkDirectory;
exports.getLock = getLock;
exports.getHttpTransferOptions = getHttpTransferOptions;

var _fsPromise = _interopRequireDefault(require("./fs-promise"));

var _async = _interopRequireDefault(require("async"));

var _path = _interopRequireDefault(require("path"));

var _asyncLock = _interopRequireDefault(require("async-lock"));

var _constants = require("./constants");

var _uploadError = _interopRequireDefault(require("./upload-error"));

var _errorCodes = _interopRequireDefault(require("./error-codes"));

var _uploadFile = _interopRequireDefault(require("./upload-file"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var lock = new _asyncLock.default();
var TEMP_PATTERNS = [/^\/~(.*)/, // catch all paths starting with ~
/^\/\.(.*)/ // catch all paths starting with .
];
var TEMP_NAME_PATTERNS = [/^[.~]/i, /^TestFile/, // InDesign: on file open, InDesign creates .dat.nosync* file, renames it TestFile, and deletes it
/\.tmp$/i, // Illustrator: on save, creates one or more *.tmp files, renames them to original file name
/\.~tmp$/i, // some default Windows applications use this file format
// Windows
/^desktop\.ini/i, /^Thumbs\.db/i, /^Adobe Bridge Cache\.bc$/i, /^Adobe Bridge Cache\.bct$/i];
/**
 * Loops through a given array, concurrently invoking the given callback. The loop will have a maximum
 * number of pending itemCallbacks at any one time. For example, if there are 100 items in the array
 * and 5 itemCallbacks are currently processing, then no more itemCallbacks will be invoked until
 * at least one of the pending itemCallbacks completes.
 *
 * @param {Array} loopArray Array to loop through.
 * @param {number} [maxConcurrent] Optionally specify how many concurrent itemCallbacks are allowed.
 *  Default is 5.
 * @param {function} itemCallback Invoked each time an item from the given array is available. Will
 *  be invoked with two parameters: the item itself and the index of the item in the array. The
 *  return value of this callback is expected to be a Promise.
 * @returns {Promise} Will be resolved when all Promises returned by the callback have been resolved.
 *  Will be resolved with an Array of all resolve values from the callback's Promises.
 */

function concurrentLoop(loopArray, maxConcurrent, itemCallback) {
  var theMaxConcurrent = maxConcurrent;
  var theItemCallback = itemCallback;

  if (typeof maxConcurrent === 'function') {
    theItemCallback = maxConcurrent;
    theMaxConcurrent = _constants.DefaultValues.MAX_CONCURRENT;
  }

  return new Promise(function (resolve, reject) {
    _async.default.eachOfLimit(loopArray, theMaxConcurrent, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(loopItem, index, itemDone) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return theItemCallback(loopItem, index);

              case 3:
                _context.next = 9;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                itemDone(_context.t0);
                return _context.abrupt("return");

              case 9:
                itemDone();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }(), function (err) {
      if (err) {
        reject(err);
        return;
      }

      resolve();
    });
  });
}
/**
 * Loops through a given array, moving on to the next item in the array only when the Promise for
 * the current item has resolved.
 *
 * @param {Array} loopArray Array to loop through.
 * @param {function} itemCallback Invoked each time an item from the given array is available. Will
 *  be invoked with two parameters: the item itself and the index of the item in the array. The
 *  return value of this callback is expected to be a Promise.
 * @returns {Promise} Will be resolved when all Promises returned by the callback have been resolved.
 *  Will be resolved with an Array of all resolve values from the callback's Promises.
 */


function serialLoop(_x4, _x5) {
  return _serialLoop.apply(this, arguments);
}
/**
 * Calculates the average of all the numbers in an array.
 *
 * @param {Array} values List of numbers for which to calculate an average.
 * @returns {number} The average value, rounded to zero decimal places.
 */


function _serialLoop() {
  _serialLoop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(loopArray, itemCallback) {
    var itemResults, i;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            itemResults = [];
            i = 0;

          case 2:
            if (!(i < loopArray.length)) {
              _context2.next = 11;
              break;
            }

            _context2.t0 = itemResults;
            _context2.next = 6;
            return itemCallback(loopArray[i], i);

          case 6:
            _context2.t1 = _context2.sent;

            _context2.t0.push.call(_context2.t0, _context2.t1);

          case 8:
            i++;
            _context2.next = 2;
            break;

          case 11:
            return _context2.abrupt("return", itemResults);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _serialLoop.apply(this, arguments);
}

function getAverage(values) {
  if (values.length) {
    var sum = values.reduce(function (x, y) {
      return x + y;
    });
    return Math.round(sum / values.length);
  }

  return 0;
}
/**
 * Utility method that provides a Promise interface for setTimeout().
 *
 * @param {number} delay The amount of time, in milliseconds, to wait before the method resolves.
 * @returns {Promise} Will be resolved when the specified delay has elapsed.
 */


function setTimeoutPromise(delay) {
  return new Promise(function (res) {
    setTimeout(res, delay);
  });
}
/**
 * Retries an operation a given number of times, exponentially increasing the amount of time between each retry by a
 * specified interval.
 *
 * @param {object} retryOptions Determines the behavior of the retry functionality.
 * @param {number} [retryOptions.retryCount] Specifies how many times, in total, the operation will be retried before giving up.
 * @param {number} [retryOptions.retryDelay] Specifies the amount of time to wait before retrying. The actual wait time will
 *   exponentially increase by this value with each retry.
 * @param {function} [retryOptions.onRetryError] Will be invoked with a single error before each retry. If all retries fail, the
 *   method will resolved with the last error instead. If this function throws an exception then the retry functionality
 *   will immediately be resolved with the thrown exception.
 * @param {function} toRetry The operation to retry. The function is expected to return a Promise, which is resolved if
 *   the operation is successful and rejected with an error if the operation fails.
 * @returns {Promise} Will be resolved successfully if no exception is thrown by the operation withing the specified
 *   number of tries. Will be rejected with the last error if all retries fail.
 */


function exponentialRetry(_x6, _x7) {
  return _exponentialRetry.apply(this, arguments);
}

function _exponentialRetry() {
  _exponentialRetry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(options, toRetry) {
    var _options, _options$retryCount, retryCount, _options$retryDelay, retryDelay, _options$onRetryError, onRetryError, lastErr, i;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (typeof options === 'function') {
              toRetry = options;
              options = {};
            }

            _options = options, _options$retryCount = _options.retryCount, retryCount = _options$retryCount === void 0 ? _constants.DefaultValues.RETRY_COUNT : _options$retryCount, _options$retryDelay = _options.retryDelay, retryDelay = _options$retryDelay === void 0 ? _constants.DefaultValues.RETRY_DELAY : _options$retryDelay, _options$onRetryError = _options.onRetryError, onRetryError = _options$onRetryError === void 0 ? function () {} : _options$onRetryError;
            lastErr = null;
            i = 1;

          case 4:
            if (!(i <= retryCount)) {
              _context3.next = 22;
              break;
            }

            _context3.prev = 5;
            _context3.next = 8;
            return toRetry();

          case 8:
            lastErr = null;
            return _context3.abrupt("break", 22);

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](5);
            lastErr = _context3.t0;

            if (!(i < retryCount)) {
              _context3.next = 19;
              break;
            }

            onRetryError(_context3.t0);
            _context3.next = 19;
            return setTimeoutPromise(retryDelay * i);

          case 19:
            i += 1;
            _context3.next = 4;
            break;

          case 22:
            if (!lastErr) {
              _context3.next = 24;
              break;
            }

            throw lastErr;

          case 24:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[5, 12]]);
  }));
  return _exponentialRetry.apply(this, arguments);
}

function buildCharRegex(charArray) {
  var regex = '[';
  charArray.forEach(function (char) {
    if (char === '\\' || char === ']') {
      regex += '\\';
    }

    regex += char;
  });
  regex += ']';
  return regex;
}
/**
 * Removes a given set of characters from the end of a string.
 *
 * @param {string} toTrim The value to be trimmed.
 * @param {Array} charArray An array of single characters to trim.
 */


function trimRight(toTrim, charArray) {
  if (toTrim && toTrim.replace) {
    return toTrim.replace(new RegExp("".concat(buildCharRegex(charArray), "*$"), 'g'), '');
  }

  return toTrim;
}
/**
 * Removes a given set of characters from the beginning of a string.
 *
 * @param {string} toTrim The value to be trimmed.
 * @param {Array} charArray An array of single characters to trim.
 */


function trimLeft(toTrim, charArray) {
  if (toTrim && toTrim.replace) {
    return toTrim.replace(new RegExp("^".concat(buildCharRegex(charArray), "*"), 'g'), '');
  }

  return toTrim;
}
/**
 * Joins a list of values together to form a URL path. Each of the given values
 * is guaranteed to be separated from all other values by a forward slash.
 *
 * @param  {...string} theArguments Any number of parameters to join.
 */


function joinUrlPath() {
  var path = '';

  for (var _len = arguments.length, theArguments = new Array(_len), _key = 0; _key < _len; _key++) {
    theArguments[_key] = arguments[_key];
  }

  theArguments.forEach(function (arg) {
    var toJoin = trimRight(trimLeft(arg, ['/']), ['/']);

    if (toJoin) {
      path += "/".concat(toJoin);
    }
  });
  return path;
}
/**
 * Removes "/content/dam" from the beginning of a given path, if its
 * present. If the path equals "/content/dam" then the method will
 * return an empty string.
 *
 * @param {string} path The path to trim.
 */


function trimContentDam(path) {
  if (!path) {
    return path;
  }

  if (path === '/content/dam') {
    return '';
  }

  var trimmed = String(path);

  if (trimmed.startsWith('/content/dam/')) {
    trimmed = trimmed.substr('/content/dam'.length);
  }

  return trimRight(trimmed, ['/']);
}
/**
 * Normalizes a path by ensuring it only contains forward slashes and does not end with a
 * slash. If the given path is falsy then the method will return an empty string.
 * @param {string} path An item's full path.
 * @returns {string} Normalized version of a path.
 */


function normalizePath(path) {
  var normPath = path;

  if (normPath) {
    normPath = normPath.replace(/\\/g, '/');

    if (normPath.charAt(normPath.length - 1) === '/') {
      normPath = normPath.substr(0, normPath.length - 1);
    }
  }

  return normPath || '';
}
/**
 * Determines whether or not a given path is either a temp file, or in a temp directory.
 * @param {string} path A file system-like path.
 * @returns {boolean} True if the path is a temp file, false otherwise.
 */


function isTempPath(path) {
  var tempPath = normalizePath(path);

  if (tempPath === '/') {
    return false;
  }

  var isTemp = TEMP_PATTERNS.some(function (pattern) {
    return pattern.test(tempPath);
  });

  if (!isTemp) {
    var pathName = _path.default.basename(tempPath);

    isTemp = TEMP_NAME_PATTERNS.some(function (pattern) {
      return pattern.test(pathName);
    });
  }

  return isTemp;
}
/**
 * Concurrently loops through all items in a directory, doing a stat
 * on each to determine if it's a directory or file. The method will
 * skip temp files and directories.
 * @param {string} directoryPath Full path to the directory to iterate.
 * @param {Array} directories All of the target directory's valid sub-directories
 *  will be added to this array.
 * @param {Array} files All of the target directory's valid sub-files will be
 *  added to this array.
 * @param {Array} errors Any errors encountered while processing the directory will
 *  be added to this array.
 * @returns {number} Total size, in bytes, of all files in the directory.
 */


function processDirectory(_x8, _x9, _x10, _x11) {
  return _processDirectory.apply(this, arguments);
}

function _processDirectory() {
  _processDirectory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(directoryPath, directories, files, errors) {
    var contents, totalSize;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            contents = false;
            totalSize = 0;
            _context5.prev = 2;
            _context5.next = 5;
            return _fsPromise.default.readdir(directoryPath);

          case 5:
            contents = _context5.sent;
            _context5.next = 11;
            break;

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](2);
            errors.push(_context5.t0);

          case 11:
            if (!contents) {
              _context5.next = 14;
              break;
            }

            _context5.next = 14;
            return concurrentLoop(contents, /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(childPath) {
                var fullChildPath, childStat;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        fullChildPath = _path.default.join(directoryPath, childPath);

                        if (isTempPath(fullChildPath)) {
                          _context4.next = 13;
                          break;
                        }

                        _context4.prev = 2;
                        _context4.next = 5;
                        return _fsPromise.default.stat(fullChildPath);

                      case 5:
                        childStat = _context4.sent;
                        _context4.next = 12;
                        break;

                      case 8:
                        _context4.prev = 8;
                        _context4.t0 = _context4["catch"](2);
                        errors.push(_context4.t0);
                        return _context4.abrupt("return");

                      case 12:
                        if (childStat.isDirectory()) {
                          directories.push({
                            path: fullChildPath
                          });
                        } else if (childStat.isFile()) {
                          files.push({
                            path: fullChildPath,
                            size: childStat.size
                          });
                          totalSize += childStat.size;
                        }

                      case 13:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[2, 8]]);
              }));

              return function (_x15) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 14:
            return _context5.abrupt("return", totalSize);

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 8]]);
  }));
  return _processDirectory.apply(this, arguments);
}

function removeEmptyDirectories(directories, files) {
  var validDirectories = [];

  for (var d = 0; d < directories.length; d++) {
    var directory = directories[d];

    var directoryPrefix = _path.default.join(directory.path, '/');

    for (var f = 0; f < files.length; f++) {
      var file = files[f];

      if (file.path.startsWith(directoryPrefix)) {
        validDirectories.push(directory);
        break;
      }
    }
  }

  return validDirectories;
}
/**
 * Walks a directory by retrieving all the directories and files
 * in the given path, then walking all those sub directories, then
 * all sub directories of those sub directories, etc. The end result
 * will be the entire tree, including all descendents, for the
 * target directory.
 * @param {string} directoryPath Directory to traverse.
 * @param {number} [maximumPaths] The maximum number of paths to
 *  process before the method gives up and throws an exception.
 *  Default value is 5000.
 * @param {boolean} [includeDescendents] If true, the method will walk
 *  descendent directories. If false, the method will only include files
 *  immediately below the given directory. Default value is true.
 */


function walkDirectory(_x12) {
  return _walkDirectory.apply(this, arguments);
}
/**
 * Creates a "thread"-specific lock on a given ID. Other threads requesting
 * a lock on the same ID won't be able to run unless there are no other
 * threads holding the lock. Once a lock is obtained, the given callback is
 * invoked; the lock will be released when the callback has finished
 * executing. The method itself returns a promise, which will resolve once
 * the callback has completed.
 * @param {string} lockId ID for which an exclusive lock will be obtained.
 * @param {function} callback Invoked when the lock has been obtained. The
 *  lock will be released when the callback has finished executing. The callback
 *  can return a Promise, and the method will wait until the Promise resolves
 *  before releasing the lock.
 * @returns {Promise} Resolves after a lock has been obtained and the given
 *  callback has finished executing.
 */


function _walkDirectory() {
  _walkDirectory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(directoryPath) {
    var maximumPaths,
        includeDescendents,
        processDirectories,
        allDirectories,
        allFiles,
        allErrors,
        walkedTotalSize,
        _processDirectories$s,
        toProcess,
        directories,
        _args6 = arguments;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            maximumPaths = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 5000;
            includeDescendents = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : true;
            processDirectories = [{
              path: directoryPath
            }];
            allDirectories = [];
            allFiles = [];
            allErrors = [];
            walkedTotalSize = 0; // this algorithm avoids recursion to prevent overflows. Instead,
            // use a stack to keep track of directories to process.

          case 7:
            if (!(processDirectories.length > 0)) {
              _context6.next = 20;
              break;
            }

            _processDirectories$s = processDirectories.shift(), toProcess = _processDirectories$s.path;
            directories = [];
            _context6.t0 = walkedTotalSize;
            _context6.next = 13;
            return processDirectory(toProcess, directories, allFiles, allErrors);

          case 13:
            walkedTotalSize = _context6.t0 += _context6.sent;
            allDirectories = allDirectories.concat(directories);

            if (includeDescendents) {
              processDirectories = processDirectories.concat(directories);
            }

            if (!(allDirectories.length + allFiles.length > maximumPaths)) {
              _context6.next = 18;
              break;
            }

            throw new _uploadError.default("Walked directory exceeded the maximum number of ".concat(maximumPaths, " paths"), _errorCodes.default.TOO_LARGE);

          case 18:
            _context6.next = 7;
            break;

          case 20:
            return _context6.abrupt("return", {
              directories: removeEmptyDirectories(allDirectories, allFiles),
              files: allFiles,
              errors: allErrors,
              totalSize: walkedTotalSize
            });

          case 21:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _walkDirectory.apply(this, arguments);
}

function getLock(_x13, _x14) {
  return _getLock.apply(this, arguments);
}
/**
 * Converts options provided in a DirectBinaryUploadOptions instance to a format
 * suitable to pass to the httptransfer module.
 * @param {object} options General upload object options.
 * @param {DirectBinaryUploadOptions} directBinaryUploadOptions Options to convert.
 */


function _getLock() {
  _getLock = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(lockId, callback) {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", lock.acquire(lockId, callback));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getLock.apply(this, arguments);
}

function getHttpTransferOptions(options, directBinaryUploadOptions) {
  // the httptransfer module accepts a full fileUrl instead of a single
  // url with individual file names. if needed, convert the format with a
  // single url and individual file names to the fileUrl format.
  var convertedFiles = directBinaryUploadOptions.getUploadFiles().map(function (uploadFile) {
    var uploadFileInstance = new _uploadFile.default(options, directBinaryUploadOptions, uploadFile);
    var transferOptions = uploadFileInstance.toJSON();

    if (uploadFile.blob) {
      // ensure blob is passed through to transfer options
      transferOptions.blob = uploadFile.blob;
    }

    return transferOptions;
  });
  return {
    uploadFiles: convertedFiles,
    headers: directBinaryUploadOptions.getHeaders(),
    concurrent: directBinaryUploadOptions.isConcurrent(),
    maxConcurrent: directBinaryUploadOptions.getMaxConcurrent()
  };
}